import { action } from 'typesafe-actions';

import { GarageTypes, GarageInterface } from './types';

// List Garage
export const listGarageRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(GarageTypes.LIST_GARAGE_REQUEST, payload);

export const listGarageSuccess = (payload: {
  garageList: GarageInterface[];
  totalCount: number;
}) => action(GarageTypes.LIST_GARAGE_SUCCESS, payload);

export const listGarageFailure = () => action(GarageTypes.LIST_GARAGE_FAILURE);

// Get Garage
export const getGarageRequest = (payload: object) =>
  action(GarageTypes.GET_GARAGE_REQUEST, payload);

export const getGarageSuccess = (payload: { garageData: GarageInterface }) =>
  action(GarageTypes.GET_GARAGE_SUCCESS, payload);

export const getGarageFailure = () => action(GarageTypes.GET_GARAGE_FAILURE);

// Filter Garage
export const filterGarageRequest = (payload: object) =>
  action(GarageTypes.FILTER_GARAGE_REQUEST, payload);

export const filterGarageSuccess = (payload: {
  garageList: GarageInterface[];
  totalCount: number;
}) => action(GarageTypes.FILTER_GARAGE_SUCCESS, payload);

export const filterGarageFailure = () =>
  action(GarageTypes.FILTER_GARAGE_FAILURE);

// Create Garage
export const createGarageRequest = (payload: object) =>
  action(GarageTypes.CREATE_GARAGE_REQUEST, payload);

export const createGarageSuccess = (payload: { garageData: GarageInterface }) =>
  action(GarageTypes.CREATE_GARAGE_SUCCESS, payload);

export const createGarageFailure = () =>
  action(GarageTypes.CREATE_GARAGE_FAILURE);

// Update Garage
export const updateGarageRequest = (payload: object) =>
  action(GarageTypes.UPDATE_GARAGE_REQUEST, payload);

export const updateGarageSuccess = (payload: { garageData: GarageInterface }) =>
  action(GarageTypes.UPDATE_GARAGE_SUCCESS, payload);

export const updateGarageFailure = () =>
  action(GarageTypes.UPDATE_GARAGE_FAILURE);

// Delete Garage
export const deleteGarageRequest = (payload: object) =>
  action(GarageTypes.DELETE_GARAGE_REQUEST, payload);

export const deleteGarageSuccess = () =>
  action(GarageTypes.DELETE_GARAGE_SUCCESS);

export const deleteGarageFailure = () =>
  action(GarageTypes.DELETE_GARAGE_FAILURE);
